const initialState = {
  countryTaxTypes: [],
  adjustmentTypes: [],
  companyCodeDetails: {},
  companyCodeDetailsError: null,
  taxRates: [],
  taxAccounting: [],
  bookToTaxDifferences: [],
  journals: [],
  localJournals: [],
  journalsDetail: [],
  taxExpense: null,
  isCalculatingProvision: false,
  isProformaCalc: false,
  isUploadingTrialBalance: false,
  isMultiTaxNonUS: false,
  calcResultsLog: [],
  isDownloadingProvisionDetails: false,
};

export default initialState;
